import { IDEAL_MINIMUM_ZOOMS_BY_MAP_ROOT_AREA_ID, } from 'mapping/constants';
import { IMappableSetting } from 'types/map';

export default function getIdealMinimumZoomForSetting({ mapRootArea: { areaKey } }: Pick<IMappableSetting, 'mapRootArea'>) {
  return IDEAL_MINIMUM_ZOOMS_BY_MAP_ROOT_AREA_ID[areaKey];
}